var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19241 4.0355L10.7279 5.57103C11.8531 6.69622 12.7222 5.82393 13.8262 4.71582C13.8739 4.66795 13.922 4.61964 13.9706 4.57103L15.6777 6.27814L11 11.5L5.7782 16.1776L4.0711 14.4705C4.1197 14.4219 4.16802 14.3738 4.21589 14.3261C5.32399 13.2221 6.19628 12.3531 5.07109 11.2279L3.53556 9.69235L2.82845 10.3995C2.43954 10.7884 1.80315 10.7884 1.41424 10.3995C1.02533 10.0106 1.02533 9.37416 1.41424 8.98525L8.48531 1.91418C8.87422 1.52527 9.51061 1.52527 9.89952 1.91418C10.2884 2.30309 10.2884 2.93948 9.89952 3.32839L9.19241 4.0355ZM13.7438 15.7004L14.5 15L15.1209 14.2491L19.0707 18.1988V19.6131H17.6565L13.7438 15.7004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9998 19.6421L19.1419 5.49997L20.5562 6.91418L6.41402 21.0563L4.9998 19.6421Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.741580e1.svg";
export { ForwardRef as ReactComponent };